import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useUserContextStore } from '@/Stores/Web/userContextStore';

import { apiClient } from '@/Clients/ApiClient';
import UserNotificationsService from '@/Services/UserNotificationsService';

import { withCache } from '@/Utils/CacheUtility';

export const usePlatformNotificationStore = defineStore('platformNotification',
    () => {
        const unreadNotificationCount = ref(0);
        const hasUnreadUserPendingActions = ref(false);
        const notifications = ref([]);
        const pendingActions = ref([]);

        const userNotificationsService = new UserNotificationsService(apiClient);

        async function getUserNotificationsWithCache(cacheKey) {
            const cachedFunction = withCache(
                userNotificationsService.getUserNotifications.bind(userNotificationsService),
                {
                    key: cacheKey,
                    cacheDuration: 50, // very short just to prevent multiple calls in a short time
                },
            );

            return await cachedFunction();
        }

        async function fetchUnreadCount() {
            const response = await userNotificationsService.getUnreadNotificationsCount();
            const { hasUnreadUserPendingActions: hasPending, unreadNotificationsCount: count } = response.data;
            unreadNotificationCount.value = count;
            hasUnreadUserPendingActions.value = hasPending;
        }

        async function fetchUserNotifications() {
            const userContextStore = useUserContextStore();
            const userId = userContextStore.userContext?.user?.userID;
            const cacheKeySuffix = userId ? `-${userId}` : '';
            const cacheKey = `userNotifications${cacheKeySuffix}`;

            const response = await getUserNotificationsWithCache(cacheKey);
            const { notifications: notifs, pendingActions: actions } = response.data;
            notifications.value = notifs;
            pendingActions.value = actions;
        }

        return {
            unreadNotificationCount,
            hasUnreadUserPendingActions,
            notifications,
            pendingActions,
            fetchUnreadCount,
            fetchUserNotifications,
        };
    },
);